import React from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { BalanceGeneralItem } from "./BoxFinancieros/BalanceGeneralItem";
import { EstadoResultadoItem } from "./BoxFinancieros/EstadoResultadoItem";
import { FlujoEfectivoITem } from "./BoxFinancieros/FlujoEfectivoITem";
import { ChartVentasNEtas } from "./ChartVentasNEtas";
import { ChartMargen } from "./ChartMargen";
import { RazonesFinancieraItem, RazonesFinancieraItem2, RazonesFinancieraItem3, RazonesFinancieraItem4 } from "./BoxFinancieros/RazonesFinancieraItem";
import { DashboardHeader } from "./DashboardHeader";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from '../../components/LoaderScreen';
import { useEffect, useState, createContext, useRef } from 'react';
import request from '../../../Helpers/API';
import { ChartGastos } from "./ChartGastos";
import { AntiguedadInventarioItem } from "./BoxFinancieros/AntiguedadInventarioItem";
import { CostoFinanciamientoItem } from "./BoxFinancieros/CostoFinanciamientoItem";
import { ResultadosSucursalItem } from "./BoxFinancieros/ResultadosSucursal";
import { NivelInventarioItem } from "./BoxFinancieros/NivelInventario";
import FiltroDashboard from "./FiltroDashboard";
// import { useBox } from "../Helper/useBox";
import { useBox } from "./useBox";
import { GetKey } from "../Actions/GetContainer";
import { GetMonthNameByNumber } from "../Helper/GetMonthNameByNumber";
import Swal from "sweetalert2";
import { RazonesFinancieraGerentesItem } from "./BoxFinancieros/RazonesFinancieraGerentesItem";
import { RotacionInventarioItem } from "./BoxFinancieros/RotacionInventarioItem";
import { RotacionCXCItem } from "./BoxFinancieros/RotacionCXCItem";

// export const DashFinancieroContext = createContext(null);
export const DashFinancieroMain = () => {
  const history = useHistory();
  const [boxstate, setBoxState] = useBox();
  const [data, setData] = useState(null);
  const [dataActualizacion, setDataActualizacion] = useState(null);
  const [permisos, setPermisos] = useState(null);
  const [sucursalesPermitidas, setSucursalesPermitidas] = useState(null);
  const [chartsLoaded, setChartsLoaded] = useState(false);
  const [titulo, setTitulo] = useState('INFORMACIÓN FINANCIERA');
  // console.log(boxstate)
  const storedState = JSON.parse(localStorage.getItem('dashboard_filtro')) || {};

  const handleClickVentas = () => {
    history.push("/Finanzas/LineasVenta", sucursalesPermitidas);
  };
  const handleClickGastos = () => {
    history.push("/Finanzas/Gastos", sucursalesPermitidas);
  };
  const handleClickMargen = () => {
    history.push("/Finanzas/MargenesDetalle");
  };
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      const fechaActual = new Date();
      const ejercicioActual = fechaActual.getFullYear();
      const mesActual = fechaActual.getMonth() + 1;
      boxstate.ejercicio = ejercicioActual;
      boxstate.periodoinicio = '1';
      boxstate.periodofin = mesActual;
      return;
    }

    const filtro = {
      ejercicio: boxstate.ejercicio,
      periodoinicio: boxstate.periodoinicio,
      periodofin: boxstate.periodofin,
    };

    localStorage.setItem('dashboard_filtro', JSON.stringify(filtro));
  }, [boxstate.ejercicio, boxstate.periodoinicio, boxstate.periodofin]);

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    boxstate.ejercicio = storedState.ejercicio || boxstate.ejercicio;
    boxstate.periodoinicio = storedState.periodoinicio || '1';
    boxstate.periodofin = storedState.periodofin || boxstate.periodofin;
    onExecute(boxstate.ejercicio, boxstate.periodoinicio, boxstate.periodofin);
  }, []);
  // console.log(boxstate)
  const onExecute = (ejercicio, periodoinicio, periodofin) => {
    // localStorage.setItem('dashboard_filtro', JSON.stringify(boxstate));
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`InfoDashboardFinanzas/Obtener_Dashboard?periodoinicio=${periodoinicio}&periodofin=${periodofin}&ejercicio=${ejercicio}&adr=${adr}&sucursales=${sucursales}`)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setData(result);
          // console.log(result)
          setPermisos(result.permisos);
          setDataActualizacion(result.actualizacionUsuario[0]);
          setSucursalesPermitidas(result.sucursalesPermiso);
          const mesInicio = GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase();
          const mesFin = GetMonthNameByNumber(boxstate.periodofin).toUpperCase();

          const tituloPeriodo = boxstate.periodoinicio === boxstate.periodofin
            ? `${mesInicio} ${boxstate.ejercicio}`
            : `${mesInicio} - ${mesFin} ${boxstate.ejercicio}`;

          setTitulo(`INFORMACIÓN FINANCIERA ${tituloPeriodo}`);
          setChartsLoaded(true);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          // reject(error);
          Swal.fire("DASHBOARD FINANCIERO", JSON.stringify(error), "error");
          // console.log(error)
          return;
        });
    });
  };
  console.log(permisos)
  return (
    <PlantillaScreen
      titulo={titulo}
      className_main={1}
      className={"dashboard-financiero"}
    >
      <LoaderScreen loader={loader} />
      <div className="dashboard-financiero-actions">
        <div className="dashboard-financiero-actions-filtro">
          <FiltroDashboard
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
            sucursales={sucursalesPermitidas}
          />
        </div>
      </div>
      {chartsLoaded && data && (
        <>
          <div className="dashboard-financiero-container scroll-4">
            <DashboardHeader data={data} permisos={sucursalesPermitidas} />
            <div className="dashboard-financiero-container-boxes">
              {permisos?.some(p => p.descripcion?.toLowerCase() === "balance general") && <BalanceGeneralItem data={data} />}
              {/* <BalanceGeneralItem data={data} /> */}
              {permisos?.some(p => p.descripcion?.toLowerCase() === "estado de resultados") && <EstadoResultadoItem data={data} permisos={sucursalesPermitidas} />}
              {/* <EstadoResultadoItem data={data} /> */}
              {permisos?.some(p => p.descripcion?.toLowerCase() === "margen bruto") && (
                <>
                  <div className="dashboard-financiero-container-box-2-row">
                    <div className="dashboard-financiero-container-box-titulo">
                      Margen Bruto
                    </div>
                    <div
                      className="dashboard-financiero-container-box-info"
                      onClick={handleClickMargen}
                    >
                      <ChartMargen data={data} />
                    </div>
                  </div>
                </>
              )}
              {/* <div className="dashboard-financiero-container-box-2-row">
                <div className="dashboard-financiero-container-box-titulo">
                  Margen Bruto
                </div>
                <div className="dashboard-financiero-container-box-info" onClick={handleClickMargen}>
                  <ChartMargen data={data} />
                </div>
              </div> */}

              {permisos?.some(p => p.descripcion?.toLowerCase() === "ventas netas") && (
                <div className="dashboard-financiero-container-box-2-row" onClick={handleClickVentas}>
                  <div className="dashboard-financiero-container-box-titulo">
                    Ventas Netas
                  </div>
                  <div className="dashboard-financiero-container-box-info">
                    <ChartVentasNEtas data={data} ejercicio={boxstate.ejercicio || boxstate.ejercicioinicio} periodoinicio={boxstate.ejercicioinicio} periodofin={boxstate.ejerciciofin} name="chart-container-ventas-netas" />
                  </div>
                </div>
              )}
              {/* <div className="dashboard-financiero-container-box-2-row" onClick={handleClickVentas}>
                <div className="dashboard-financiero-container-box-titulo">
                  Ventas Netas
                </div>
                <div className="dashboard-financiero-container-box-info">
                  <ChartVentasNEtas data={data} name='chart-container-ventas-netas' />
                </div>
              </div> */}

              {permisos?.some(p => p.descripcion?.toLowerCase() === "gastos") && (
                <div className="dashboard-financiero-container-box-2-row" onClick={handleClickGastos}>
                  <div className="dashboard-financiero-container-box-titulo">
                    Gastos
                  </div>
                  <div className="dashboard-financiero-container-box-info">
                    <ChartGastos data={data} sucursales={sucursalesPermitidas} name="chart-container-gastos" />
                  </div>
                </div>
              )}
              {/* <div className="dashboard-financiero-container-box-2-row" onClick={handleClickGastos}>
                <div className="dashboard-financiero-container-box-titulo">
                  Gastos
                </div>
                <div className="dashboard-financiero-container-box-info">
                  <ChartGastos data={data} name='chart-container-gastos' />
                </div>
              </div> */}
              {permisos?.some(p => p.descripcion?.toLowerCase() === "antiguedad de inventario") && <AntiguedadInventarioItem data={data} sucursales={sucursalesPermitidas} />}
              {/* <AntiguedadInventarioItem data={data} /> */}
              {permisos?.some(p => p.descripcion?.toLowerCase() === "costo integral de financiamiento") && <CostoFinanciamientoItem data={data} sucursales={sucursalesPermitidas} />}
              {/* <CostoFinanciamientoItem data={data} /> */}
              {permisos?.some(p => p.descripcion?.toLowerCase() === "resultados por sucursal") && <ResultadosSucursalItem data={data} sucursales={sucursalesPermitidas} />}
              {/* <ResultadosSucursalItem data={data} /> */}
              {permisos?.some(p => p.descripcion?.toLowerCase() === "nivel de inventario") && <NivelInventarioItem data={data} sucursales={sucursalesPermitidas} />}
              {/* <NivelInventarioItem data={data} /> */}
              {permisos?.some(p => p.descripcion?.toLowerCase() === "razones financieras") && <RazonesFinancieraItem data={data} sucursales={sucursalesPermitidas} />}
              {permisos?.some(p => p.descripcion?.toLowerCase() === "rotacion de inventario") && <RotacionInventarioItem data={data} sucursales={sucursalesPermitidas} />}
              {(permisos?.some(p => p.descripcion?.toLowerCase() === "rotacion cxc") || permisos?.some(p => p.descripcion?.toLowerCase() === "rotacion cxc optima")) && (
                <div style={{ display: "flex", flexDirection: "row", gap: "-5px", marginTop: "20px" }}>
                  {permisos?.some(p => p.descripcion?.toLowerCase() === "rotacion cxc") && <RotacionCXCItem data={data} sucursales={sucursalesPermitidas} sucursalesSeleccionadas={boxstate.pv.sucursal} ejercicioSelect={boxstate.ejercicio} periodoSelect={boxstate.periodofin} />}
                  {permisos?.some(p => p.descripcion?.toLowerCase() === "rotacion cxc optima") && <RotacionCXCItem data={data} sucursales={sucursalesPermitidas} sucursalesSeleccionadas={boxstate.pv.sucursal} ejercicioSelect={boxstate.ejercicio} periodoSelect={boxstate.periodofin} optima={true}/>}
                </div>
              )}
              {permisos?.some(p => p.descripcion?.toLowerCase() === "razones financieras gerentes") && <RazonesFinancieraGerentesItem data={data} sucursales={sucursalesPermitidas} />}
              {/* <RazonesFinancieraItem data={data} /> */}
              {/* <RazonesFinancieraItem2 />
          <RazonesFinancieraItem3 />
          <RazonesFinancieraItem4 /> */}
            </div>

          </div>
          <div class="header-notice">
            <span className="center-text">(Todas las cifras de esta pantalla están expresadas en miles de pesos)</span>
            <span className="right-text">Ultima actualización por: {dataActualizacion.nombre} el {dataActualizacion.fecha}</span>
          </div>
        </>
      )}
    </PlantillaScreen>
  );
};
